import imagen1 from "../imagenesproyectos/formula-1-logo-7.png";
import imagen2 from "../imagenesproyectos/logotipo-canchasya.png";
import imagen3 from "../imagenesproyectos/Screenshot Game.png";
import imagen4 from "../imagenesproyectos/maestro-lee-logo-no-white.png";
import imagen5 from "../imagenesproyectos/ChatGPT Image Dec 5, 2025, 04_56_17 PM.png";
import imagen6 from "../imagenesproyectos/Image_20251120_174650.png";
import imagen7 from "../imagenesproyectos/Screenshot 2026-01-27 161221.png";

import imagen8 from "../imagenesproyectos/Screenshot 2026-04-06 153441.png";
import imagen9 from "../imagenesproyectos/icon.png";

const projectsData = [
  {
    Name: "TravelBuddy",
    imagen: imagen7,
    fechaRealizado: "10/01/2026",
    LinkGit: "https://github.com/vapretito/",
    LinkWeb: "https://demo-agentai-ai.vercel.app/",
    tagline: "TravelBuddy VE es un chat embebido que responde en tiempo real, te arma itinerarios a tu medida y te recomienda rincones increíbles de toda Venezuela.",
    stack: ["React", "JS", "Responsive", "UX"],
    featured: true,
  },
  {
    Name: "MaestroLee",
    imagen: imagen4,
    fechaRealizado: "02/11/2025",
    LinkGit: "https://github.com/vapretito/",
    LinkWeb: "https://maestrolee.vercel.app/",
    tagline: "Web comercial para restaurante, enfocada en UX y pedidos online.",
    stack: ["React", "JS", "Responsive", "UX"],
    featured: true,
  },
  {
    Name: "WriteAI",
    imagen: imagen5,
    fechaRealizado: "01/09/2025",
    LinkGit: "https://github.com/vapretito/",
    LinkWeb: "https://writai.zunzun.ai/",
    tagline: "Proyecto creativo con IA para generación de escritura.",
    stack: ["AI", "Python", "SVG", "Producto"],
    featured: true,
  },
  {
    Name: "CPMS",
    imagen: imagen6,
    fechaRealizado: "01/11/2025",
    LinkGit: "https://github.com/vapretito/",
    LinkWeb: "https://cpms.accounting.care/",
    tagline: "Sistema de gestión de placement con dashboard y roles.",
    stack: ["React", "Node", "MongoDB", "Dashboard"],
    featured: true,
  },
  {
    Name: "TaTeTi",
    imagen: imagen8,
    fechaRealizado: "06/04/2026",
    LinkGit: "https://github.com/vapretito/",
    LinkWeb: "https://tictactoe-sigma-lilac.vercel.app/",
    tagline: "Juego de TicTacToe",
    stack: ["React", "JS", "Responsive", "UX"],
    featured: true,
  },
  {
    Name: "Generator QR",
    imagen: imagen9,
    fechaRealizado: "11/04/2026",
    LinkGit: "https://github.com/vapretito/",
    LinkWeb: "https://qr-generator-neon-seven.vercel.app/",
    tagline: "Generador de QR",
    stack: ["React", "JS", "Responsive", "UX"],
    featured: true,
  },

  {
    Name: "CanchasYa",
    imagen: imagen2,
    fechaRealizado: "02/11/2023",
    LinkGit: "https://github.com/CanchaYAPF/CanchaYA",
    LinkWeb: "https://cancha-ya-git-pre-develop-canchayas-projects.vercel.app/",
    tagline: "Plataforma para reservar canchas y gestionar disponibilidad.",
    stack: ["React", "Node", "REST"],
  },
  {
    Name: "Tarot",
    imagen:
      "https://static.vecteezy.com/system/resources/thumbnails/046/396/592/small_2x/pentacles-tarot-cards-set-png.png",
    fechaRealizado: "05/05/2025",
    LinkGit: "https://github.com/vapretito/tarot-chatgpt-eleven",
    LinkWeb: "https://tarot-chatgpt-eleven.onrender.com/",
    tagline: "App interactiva de tarot con integración AI/voz.",
    stack: ["React", "AI", "Render"],
  },
  {
    Name: "GameJump",
    imagen: imagen3,
    fechaRealizado: "05/05/2025",
    LinkGit: "https://github.com/vapretito/musicjump",
    LinkWeb: "https://musicjump.vercel.app/",
    tagline: "Juego web con mecánicas rítmicas y UI dinámica.",
    stack: ["JS", "Canvas", "Juego"],
  },
  {
    Name: "F1",
    imagen: imagen1,
    fechaRealizado: "16/10/2023",
    LinkGit: "https://github.com/vapretito/cr-pi-drivers-main",
    LinkWeb: null,
    tagline: "Proyecto de datos y visualización sobre Fórmula 1.",
    stack: ["React", "API", "Data"],
  },
  {
    Name: "VideoGames",
    imagen:
      "https://media.istockphoto.com/id/1334436084/es/foto/vista-de-arriba-hacia-abajo-de-coloridos-accesorios-de-juego-iluminados-sobre-la-mesa.jpg?s=612x612&w=0&k=20&c=fcCloH-zF7rFZzUYq6-jFpbEuq5DiipnHX5ZZWHRThE=",
    fechaRealizado: "02/09/2023",
    LinkGit: "https://github.com/vapretito/PI-Videogames-main",
    LinkWeb: null,
    tagline: "App de videojuegos con búsqueda, filtros y detalle.",
    stack: ["React", "Redux", "API"],
  },
];

export default projectsData;
